import VideoList from "../components/VideoList";

const ListVideoPage = () => {
  return (
    <VideoList />
  );
};

export default ListVideoPage;
